import BaseWorkbenchService from '@src/slide/application/service/workbench-service/core/base';
import { LoaderType } from '@src/slide/application/service/workbench-service/core/workbench-service.interface';
import { WorkbenchLoader, WorkbenchPC } from '@tencent/workbench';

export default class PcWorkbenchService extends BaseWorkbenchService {
    protected load(loader: LoaderType<WorkbenchLoader>, container: HTMLElement) {
        WorkbenchPC.load(loader, container);
    }
}
